export const peopleAlsoAskTitles = {
    FR: [
        "Questions fréquentes",
        "Réponses aux questions courantes",
        "Informations complémentaires",
        "Questions et réponses",
        "Clarifications",
        "Doutes et réponses",
        "Aide supplémentaire",
        "Conseils pratiques",
        "Foire aux questions",
        "Réponses aux interrogations",
        "Plus d'informations",
        "Nous répondons à vos questions",
        "En savoir plus",
        "En bref",
    ],
    ES: [
        "Preguntas más frecuentes",
        "Respuestas a las preguntas más frecuentes",
        "Información complementaria",
        "Preguntas y respuestas",
        "Aclaraciones",
        "Dudas y respuestas",
        "Ayuda complementaria",
        "Consejos prácticos",
        "Preguntas más frecuentes",
        "Respuestas a las preguntas",
        "Más información",
        "Respondemos a sus preguntas",
        "Más información",
        "En breve",
    ],
    UK: [
        "Frequently asked questions",
        "Answers to frequently asked questions",
        "Additional information",
        "Questions and answers",
        "Clarifications",
        "Doubts and answers",
        "Additional help",
        "Practical advice",
        "Frequently asked questions",
        "Answers to questions",
        "More information",
        "We answer your questions",
        "More information",
        "In brief",
    ],
    DE: [
        "Häufig gestellte Fragen",
        "Antworten auf häufig gestellte Fragen",
        "Zusätzliche Informationen",
        "Fragen und Antworten",
        "Klarstellungen",
        "Zweifel und Antworten",
        "Zusätzliche Hilfe",
        "Praktische Tipps",
        "Häufig gestellte Fragen",
        "Antworten auf Fragen",
        "Weitere Informationen",
        "Wir beantworten Ihre Fragen",
        "Mehr erfahren",
        "In Kürze",
    ],
    AT: [
        "Häufig gestellte Fragen",
        "Antworten auf häufig gestellte Fragen",
        "Zusätzliche Informationen",
        "Fragen und Antworten",
        "Klarstellungen",
        "Zweifel und Antworten",
        "Zusätzliche Hilfe",
        "Praktische Tipps",
        "Häufig gestellte Fragen",
        "Antworten auf Fragen",
        "Weitere Informationen",
        "Wir beantworten Ihre Fragen",
        "Mehr erfahren",
        "In Kürze",
    ],
    PT: [
        "Perguntas frequentes",
        "Respostas às perguntas mais frequentes",
        "Informações adicionais",
        "Perguntas e respostas",
        "Esclarecimentos",
        "Dúvidas e respostas",
        "Ajuda adicional",
        "Conselhos práticos",
        "Perguntas frequentes",
        "Respostas às perguntas",
        "Mais informações",
        "Respondemos às suas perguntas",
        "Para saber mais",
        "Em resumo",
    ],
    IT: [
        "Domande frequenti",
        "Risposte alle domande più frequenti",
        "Informazioni aggiuntive",
        "Domande e risposte",
        "Chiarimenti",
        "Dubbi e risposte",
        "Aiuto supplementare",
        "Consigli pratici",
        "Domande frequenti",
        "Risposte alle domande",
        "Ulteriori informazioni",
        "Rispondiamo alle vostre domande",
        "Ulteriori informazioni",
        "In breve",
    ],
};
